/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PasskeyDeviceInfo { 
    /**
     * Credential ID (Base64URL encoded)
     */
    credential_id: string;
    /**
     * Nome descrittivo del dispositivo
     */
    display_name?: string;
    /**
     * Data di registrazione
     */
    registered_at: string;
    /**
     * Data di scadenza
     */
    expires_at: string;
    /**
     * Ultimo utilizzo
     */
    last_used_at?: string;
}

